// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-button-sm[data-v-0519052c]{height:35px;width:35px;font-size:.875rem;padding:.7rem}.p-component[data-v-0519052c]:disabled,.p-disabled[data-v-0519052c]{opacity:.8}.p-dropdown[data-v-0519052c]{min-width:200px}", ""]);
// Exports
module.exports = exports;
